import { ReactNode } from 'react';

export enum TOAST_STATE {
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning',
}

export interface ShowToastOptions {
	title?: string | ReactNode;
	message?: string | ReactNode;
	theme?: 'light';
	state?: `${TOAST_STATE}`;
	className?: string;
	dataTestId?: string;
	id?: string;
	redirecting?: boolean;
}
